import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-dcalendar',
  templateUrl: './dcalendar.component.html',
  styleUrls: ['./dcalendar.component.scss']
})
export class DcalendarComponent implements OnInit {
random: string = '_' + Math.random().toString(36).substr(2, 9);
  constructor() { }

  ngOnInit() {
  }
ngAfterViewInit() {

 $('#'+this.random).dcalendar();
}
}
